export const AGORA_APP_ID = 'aab8b8f5a8cd4469a63042fcfafe7063'
